import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { backend } from '../i18n-service';

export function useI18n(namespace, loader) {
    useState(() => backend.registerResolver(namespace, loader));

    return useTranslation(namespace);
}
